import React, { useState, useCallback } from 'react';
import { DebounceInput } from 'react-debounce-input';
import onClickOutside from 'react-onclickoutside';

import { detectIconById } from '../../common/enum'
import axios from '../../axios';
import './styles.scss';

function SearchPlayerComplete(props) {
    const { placeholder, onPlayerClick } = props;

    const [suggestions, setSuggestions] = useState([]);
    const [toggle, setToggle] = useState(false);

    const onSearch = useCallback(async (value) => {
        try {
            const { data } = await axios.get('/api/masters/players', {
                params: {
                    keyword: value,
                },
            });
            setSuggestions(data);
            setToggle(true);
        } catch (e) {
            setSuggestions([]);
        }
    }, []);

    SearchPlayerComplete.handleClickOutside = useCallback(() => {
        setToggle(false);
    }, []);

    return <div style={{ position: 'relative' }} className={'search-autocomplete-dsa'}>
        <div className="form-group">
            <span className=" form-control-feedback">
                <img alt="search" src="/img/ic_search_top_svg.svg" />
            </span>
            <DebounceInput
                className="form-control"
                style={{ outline: 'none' }}
                onFocus={(e) => {
                    if (!e.target.value) {
                        return;
                    }
                    setToggle(true);
                }}
                placeholder={placeholder}
                minLength={2}
                debounceTimeout={300}
                onChange={e => {
                    if (!e.target.value) {
                        setToggle(false);
                        return;
                    }
                    onSearch(e.target.value);
                }}
            />
            {
                toggle &&
                <div className="dropdown">
                    {
                        suggestions.map((value, key) => {
                            return (
                                <div key={key} className="items" onClick={() => {
                                    onPlayerClick(value);
                                    setToggle(false);
                                }}>
                                    <span className="fa fa-search form-control-feedback" />
                                    <img src={detectIconById(value.team.id)} alt="team-name" />
                                    <span className="text">{value.player_name}</span>
                                    <span style={{ color: '#74818A', fontSize: 13 }}>{value.uniform_number}</span>
                                </div>
                            )
                        })}
                </div>
            }
        </div>
    </div>
}

const clickOutsideConfig = {
    handleClickOutside: () => SearchPlayerComplete.handleClickOutside
};

export default onClickOutside(SearchPlayerComplete, clickOutsideConfig);
